"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeHxFetchCalendarSharingPermissionForRecipientResults = void 0;
function deserializeHxFetchCalendarSharingPermissionForRecipientResults(values) {
    var i = 0;
    var displayName = values[i++];
    var allowedDetailLevelsValues = values[i++];
    var allowedDetailLevels = new Array(allowedDetailLevelsValues.length);
    for (var index = 0; index < allowedDetailLevelsValues.length; index++) {
        allowedDetailLevels[index] = allowedDetailLevelsValues[index];
    }
    var currentDetailLevel = values[i++];
    var isInsideOrganization = values[i++];
    var isRemovable = values[i++];
    if (i != values.length) {
        throw "Result values not parsed completely";
    }
    return { displayName: displayName, allowedDetailLevels: allowedDetailLevels, currentDetailLevel: currentDetailLevel, isInsideOrganization: isInsideOrganization, isRemovable: isRemovable };
}
exports.deserializeHxFetchCalendarSharingPermissionForRecipientResults = deserializeHxFetchCalendarSharingPermissionForRecipientResults;
